import React from 'react';
import { SERVICES } from '../mock';

export default function Services() {
  const flagship = SERVICES[0];
  const rest = SERVICES.slice(1);
  return (
    <section id="services" className="py-24 md:py-32 border-b border-black/10">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-8 items-end">
          <div className="lg:col-span-7">
            <div className="eyebrow mono-font text-black/60">What We Do</div>
            <h2 className="display-font mt-8 text-[10vw] md:text-[4.6rem] leading-[0.95]">
              Full-stack <span className="accent-red">capability.</span>
            </h2>
          </div>
          <p className="lg:col-span-4 lg:col-start-9 text-black/60">
            From a single embedded engineer to a fully managed product pod — we scale to the shape of your problem.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Flagship spans full row */}
          <div className="relative md:col-span-2 card-hover rounded-xl border border-black/10 bg-white bg-grid p-8 md:p-10 min-h-[280px] flex flex-col justify-between overflow-hidden">
            <div className="flex items-start justify-between">
              <div className="num-font text-black/50">{flagship.n}</div>
              <span className="bg-accent text-white mono-font px-2.5 py-1 rounded">Flagship</span>
            </div>
            <div className="mt-auto">
              <h3 className="display-font text-4xl md:text-5xl text-black">{flagship.title}</h3>
              <p className="mt-4 text-black/60 max-w-xl">{flagship.body}</p>
            </div>
          </div>

          {rest.map((s) => (
            <div key={s.n} className="card-hover rounded-xl border border-black/10 bg-white bg-grid p-8 md:p-10 min-h-[220px] flex flex-col justify-between">
              <div className="num-font text-black/50">{s.n}</div>
              <div>
                <h3 className="display-font text-2xl md:text-3xl text-black">{s.title}</h3>
                <p className="mt-3 text-black/60">{s.body}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
